import { Chip } from '@heroui/react';
import { useGlobalComponent } from '@rhino-project/core/hooks';
import {
  useTableInheritedProps,
  TableInheritedProps
} from '@rhino-project/core/hooks';

export const CellBadgeBase = ({
  empty = '-',
  ...props
}: TableInheritedProps & { empty?: string }) => {
  const { getValue, inheritedProps } = useTableInheritedProps(props);

  if (!getValue!()) return <div {...inheritedProps}>{empty}</div>;

  return <Chip {...inheritedProps}>{getValue!()}</Chip>;
};

export const CellBadge = (props: TableInheritedProps) =>
  useGlobalComponent('CellBadge', CellBadgeBase, props);
